import SocialFeed from "./SocialFeed";

export default SocialFeed